#import "../../../graphql-wrappers/graphql/fragments/edition-stub-fragment.graphql"

fragment TemplateStubFragment on Campaign {
    id
    name
    htmlUrlPath
    deletedTime
    edition {
        ...EditionStubFragment
    }
}
